// src/pages/MS/MSU101F2.jsx
import React, {useEffect, useState} from 'react';

import Button from "components/Button/Button";
import SelectBox from "components/SelectBox/SelectBox";
import SwitchGroup from "components/Button/SwitchGroup";
import {postData} from "utils/TransactionUtil";
import styleCom from "../RE/REGCOM.module.scss";
import Table from "../../components/Table/Table";
import InputUnitText from "components/InputText/InputUnitText";
import toast from "../../components/Toast/Toast";

import Modal from "components/Modal/Modal";
import MSU101F4 from "pages/MS/MSU101F4"; //암호초기화


const MSU101F2 = ({handle_Close, selLginId, comHandleClick_Save}) => {

    //form load
    useEffect(() => {
        //공통코드 기관정보 호출
        getComDtlsData();
    }, []);


    useEffect(() => {
        //(공통) 모달 창 "확인(적용)" 버튼 클릭
        comHandleClick_Save(() => {
            const fieldsToCompare = ["userNm", "useYn", "userDscr"];
            const isSame = fieldsToCompare.every((key) => userDtl[key] === chkUserDtl[key])
            if(isSame){
                toast({ type: 'info', message: '변경된 내역이 없습니다.'});
            }else{
                svcUpdateUser();
            }
        });
    }, [comHandleClick_Save]);

    const [comHsptObj, setComHsptObj] = useState([]);
    const [comRoleObj, setComRoleObj] = useState([]);
    const [userDtl, setUserDtl] = useState({
        lginId:'', userNm:'', userPw:'', userPwR:'', hsptCd:'', userType:'',
        ehrLginId:'', hsptNm:'', mcdpCd:'', mcdpNm:'' , useYn:'',
        userDscr:'', rank:'', tlno:'', clno:'', emailId:'',
        roleNm:'', roleId:'', modInfo:'', pldgAtchFileId:'', approAtchFileId:'',
        pldgAtchFileNm:'', approAtchFileNm:''
    });
    const [chkUserDtl, setChkUserDtl] = useState(userDtl);

    const [roleMemberList, setRoleMemberList] = useState([]);

    useEffect(() => {
        //사용자 정보 조회
        const getUserDtl = async()  => {
            let param = {
                lginId : selLginId
            }
            const res = await postData("/MSU/getUserInfo", param);
            setUserDtl(res.userDtl);
            setChkUserDtl(res.userDtl);
            setRoleMemberList(res.roleMemberList);


        };
        getUserDtl();

    }, []);


    const [isModalChangePw, setIsModalChangePw] = useState(false); //암호초기화

    //팝업 닫기
    const handleModalChangePw_Close = () => {
        setIsModalChangePw(false);
    }

    const btnClick_changePw = (e) => {
        setIsModalChangePw(true);
    }


    /* Call Service====================================================================================================*/    
    
    async function getComDtlsData() {
        //공통 기관정보
        const param1 = {comGrpCd:"HSPT_CD"}
        const resultData1 = await postData("/getComDtlsCd", param1);
        setComHsptObj(resultData1);

        //공통 역할정보
        const param2 = {comGrpCd:"ROLE_ID"}
        const resultData2 = await postData("/getComDtlsCd", param2);
        setComRoleObj(resultData2);
    }
    
    async function svcUpdateUser() {
        let result = await postData("/MSU/updateUSerInfo", userDtl);
        toast({ type: 'info', message: '적용이 완료되었습니다.'});
        handle_Close();

    }



    return(
        <main>
            <div style={{display:"flex",justifyContent:"flex-end", marginBottom:"10px"}}>
                <Button variant="Secondary" size="md" addStyle={{width: "100px", height: "35px"}}
                        onClick={() => btnClick_changePw()}>암호 초기화 </Button>

            </div>
            <div className={styleCom.main_wrap} style={{marginBottom: "10px"}}>
                <Table variant='default' rowCnt={6} colSize={['25%', '75%']} rowSize={'56px'}>
                    <div>기관</div>
                    <div>
                        <SelectBox options={comHsptObj} value={userDtl.hsptCd}
                                   valueKey="comnDtlsCd" labelKey="detlCdNm"
                                   onChange={(val) => setUserDtl({...userDtl, hsptCd: val})}
                                   isAllExpr={false} width={"64%"} isDisabled={true}
                        />
                    </div>
                    <div>역할(그룹)</div>
                    <div>
                        <SelectBox options={comRoleObj} value={userDtl.roleId}
                                   valueKey="comnDtlsCd" labelKey="detlCdNm"
                                   onChange={(val) => setUserDtl({...userDtl, roleId: val})}
                                   isAllExpr={false} width={"64%"} isDisabled={true}
                        />
                    </div>
                    <div>사용자 ID</div>
                    <div>
                        <InputUnitText
                            type="text"
                            name="lginId"
                            value={userDtl.lginId}
                            readOnly={true}
                        />
                    </div>
                    <div>사용자명</div>
                    <div>
                        <InputUnitText
                            type="text"
                            name="userNm"
                            value={userDtl.userNm}
                            onChange={e => setUserDtl({...userDtl, userNm: e.target.value})}
                            readOnly={true}
                        />
                    </div>
                    <div>사용여부</div>
                    <div>
                        <SwitchGroup
                            items={{"사용": "Y", "미사용": "N"}}
                            addStyle={{width: "108px", height: "40px"}}
                            value={userDtl.useYn}
                            onClick={(value) => setUserDtl({...userDtl, useYn: value})}/>
                    </div>
                    <div>비고</div>
                    <div style={{height: "150px"}}>
                        <textarea
                            style={{height: "130px", width: "100%"}}
                            name="userDscr"
                            value={userDtl.userDscr}
                            onChange={(e) => setUserDtl({...userDtl, userDscr: e.target.value})}
                        />
                    </div>

                </Table>
            </div>
            <Modal
                open={isModalChangePw}
                handle_Close={handleModalChangePw_Close}
                title="사용자암호 초기화"
                width ="736px"
                height="450px"
                isHeader={true}
                //bottomBtnText={{cancel:"취소텍스트",confirm:"확인 텍스트"}}
                bottomBtnText={{cancel:"취소",confirm:"변경(저장)"}}
                isBottom={true}>
                <MSU101F4 handle_Close={handleModalChangePw_Close}
                          tarLginId={selLginId} tarUserNm={userDtl.userNm}
                />
            </Modal>
        </main>
    )
}
export default MSU101F2;